/* eslint-disable no-prototype-builtins */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-undef */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";
import { IconButton, Icons } from "@pushpress/shared-components";
import { CSVLink } from "react-csv";
import moment from "moment";
import { getData, getBuckets } from "../../../redux/actions/reportActions";

const formatDate = (d) => moment(d).format("M/D/YYYY h:mma");

class CSVDownloader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false,
    };
    this.csvLinkEl = React.createRef();
    this.data = [];
    this.limit = 5000;
    this.clientId = props.client;
    this.filters = props.filters;

    this.headers = [
      { label: "User Uuid", key: "userUuid" },
      { label: "Full Name", key: "fullName" },
      { label: "Status", key: "status" },
      { label: "Class Date", key: "classDate" },
      { label: "Class End Date", key: "classEndDateFull" },
      { label: "Late Cancel Date", key: "lateCancelDate" },
      { label: "Member Profile", key: "memberUrl" },
      { label: "Reservation Created", key: "reservationCreated" },
      { label: "No shows in last 90 days", key: "noShowSummaryRange" },
      { label: "Total No shows", key: "noShowSummary" },
      { label: "Late Cancels in last 90 days", key: "lateCancelSummaryRange" },
      { label: "Total Late Cancels", key: "lateCancelSummary" },
      { label: "Charged in last 90 days", key: "chargedSummaryRange" },
      { label: "Total Charged", key: "chargedSummary" },
      { label: "Forgiven in last 90 days", key: "forgivenSummaryRange" },
      { label: "Total Forgiven", key: "forgivenSummary" },
    ];
  }

  getReportData = async (from, size) => {
    const { filters } = this.props;

    const {
      data,
      total: { value: totalRows },
    } = await getData({ clientId: this.clientId, from, size, filters });

    this.data = this.data.concat(data);
    const start = from + this.limit;
    if (totalRows > start) {
      await this.getReportData(start, this.limit);
    }
  };

  addSummaryData = async (data) => {
    const promises = [];
    promises.push(getBuckets(this.clientId));
    promises.push(getBuckets(this.clientId, 90));
    const [summary, summaryPeriod] = await Promise.all(promises);

    const dataWithSummary = data.map((el) => {
      el.classDate = formatDate(el.classDate);
      el.lateCancelDate = formatDate(el.lateCancelDate);
      el.reservationCreated = formatDate(el.reservationCreated);
      el.noShowSummary = summary.noShow.hasOwnProperty(el.userUuid)
        ? summary.noShow[el.userUuid]
        : 0;
      el.lateCancelSummary = summary.lateCancel.hasOwnProperty(el.userUuid)
        ? summary.lateCancel[el.userUuid]
        : 0;

      el.noShowSummaryRange = summaryPeriod.noShow.hasOwnProperty(el.userUuid)
        ? summary.noShow[el.userUuid]
        : 0;
      el.lateCancelSummaryRange = summaryPeriod.lateCancel.hasOwnProperty(
        el.userUuid,
      )
        ? summary.lateCancel[el.userUuid]
        : 0;

      el.chargedSummary = summary.charged.hasOwnProperty(el.userUuid)
        ? summary.charged[el.userUuid]
        : 0;
      el.forgivenSummary = summary.forgiven.hasOwnProperty(el.userUuid)
        ? summary.forgiven[el.userUuid]
        : 0;

      el.chargedSummaryRange = summaryPeriod.charged.hasOwnProperty(el.userUuid)
        ? summary.charged[el.userUuid]
        : 0;
      el.forgivenSummaryRange = summaryPeriod.forgiven.hasOwnProperty(
        el.userUuid,
      )
        ? summary.forgiven[el.userUuid]
        : 0;

      return el;
    });
    return dataWithSummary;
  };

  downloadReport = async () => {
    this.data = [];
    this.setState({ data: [], loading: true });
    await this.getReportData(0, this.limit);
    const { data } = this;
    const dataWithSummary = await this.addSummaryData(data);
    this.setState({ data: dataWithSummary, loading: false }, () => {
      setTimeout(() => {
        this.csvLinkEl.current.link.click();
      });
    });
  };

  render() {
    const { data, loading } = this.state;

    return (
      <div>
        <IconButton
          icon={Icons.Download}
          tooltip="Download"
          color={loading ? "#7da8d4" : "#2A3540"}
          value={loading ? "Downloading..." : "Export to CSV"}
          onClick={this.downloadReport}
          disabled={loading}
        />
        <CSVLink
          headers={this.headers}
          data={data}
          filename="no-show-late-cancel-report.csv"
          ref={this.csvLinkEl}
        />
      </div>
    );
  }
}

export default CSVDownloader;
